import "../../../resources/less/Admin/LoggedOut/InformationPage.less";

class informationPage {}

$(window).on("load", () => {
  new informationPage();
});
